// GENERATED CODE
// This file is generated by a Python script so do not change it, change the script!
// Script: tools/codegen/generate_account_group_names.py
// Template: tools/codegen/templates/audit/audit_account_groups.ts

export const allAccountGroups: string[] = [
  '_10XX',
  '_11XX',
  '_12XX',
  '_13XX',
  '_14XX',
  '_15XX',
  '_16XX',
  '_17XX',
  '_18XX',
  '_19XX',
  '_20XX',
  '_21XX',
  '_22XX',
  '_23XX',
  '_24XX',
  '_25XX',
  '_26XX',
  '_27XX',
  '_28XX',
  '_29XX',
  '_30XX',
  '_39XX',
  '_4XXX',
  '_5XXX',
  '_6XXX',
  '_7XXX',
  '_78XX',
  '_80XX',
  '_88XX',
  '_89XX',
];

export const allAccountGroupNames: string[] = [
  '10XX',
  '11XX',
  '12XX',
  '13XX',
  '14XX',
  '15XX',
  '16XX',
  '17XX',
  '18XX',
  '19XX',
  '20XX',
  '21XX',
  '22XX',
  '23XX',
  '24XX',
  '25XX',
  '26XX',
  '27XX',
  '28XX',
  '29XX',
  '30XX',
  '39XX',
  '4XXX',
  '5XXX',
  '6XXX',
  '7XXX',
  '78XX',
  '80XX',
  '88XX',
  '89XX',
];

export function auditAccountGroupName(groupId: string): string {
  switch (groupId) {
    case '10XX':
      return 'Immateriella anläggningstillgångar';
    case '11XX':
      return 'Byggnader och mark';
    case '12XX':
      return 'Maskiner och inventarier';
    case '13XX':
      return 'Finansiella anläggningstillgångar';
    case '14XX':
      return 'Lager och pågående arbeten';
    case '15XX':
      return 'Kundfordringar';
    case '16XX':
      return 'Övriga kortfristiga fordringar';
    case '17XX':
      return 'Förutbetalda kostnader och upplupna intäkter';
    case '18XX':
      return 'Kortfristiga placeringar';
    case '19XX':
      return 'Kassa och bank';
    case '20XX':
      return 'Eget kapital';
    case '21XX':
      return 'Obeskattade reserver';
    case '22XX':
      return 'Avsättningar';
    case '23XX':
      return 'Långfristiga skulder';
    case '24XX':
      return 'Kortfristiga skulder till kreditinstitut, kunder och leverantörer';
    case '25XX':
      return 'Skatteskulder';
    case '26XX':
      return 'Moms och särskilda punktskatter';
    case '27XX':
      return 'Personalens skatter, avgifter och löneavdrag';
    case '28XX':
      return 'Övriga kortfristiga skulder';
    case '29XX':
      return 'Upplupna kostnader och förutbetalda intäkter';
    case '30XX':
    case '31XX':
    case '32XX':
    case '33XX':
    case '34XX':
    case '35XX':
    case '36XX':
    case '37XX':
    case '38XX':
      return 'Intäkter';
    case '39XX':
      return 'Övriga rörelseintäkter';
    case '40XX':
    case '41XX':
    case '42XX':
    case '43XX':
    case '44XX':
    case '45XX':
    case '46XX':
    case '47XX':
    case '48XX':
    case '49XX':
      return 'Inköp av varor och material';
    case '50XX':
    case '51XX':
    case '52XX':
    case '53XX':
    case '54XX':
    case '55XX':
    case '56XX':
    case '57XX':
    case '58XX':
    case '59XX':
      return 'Övriga kostnader';
    case '60XX':
    case '61XX':
    case '62XX':
    case '63XX':
    case '64XX':
    case '65XX':
    case '66XX':
    case '67XX':
    case '68XX':
    case '69XX':
      return 'Övriga kostnader';
    case '70XX':
    case '71XX':
    case '72XX':
    case '73XX':
    case '74XX':
    case '75XX':
    case '76XX':
    case '77XX':
      return 'Personalkostnader';
    case '78XX':
    case '79XX':
      return 'Avskrivningar/övriga rörelsekostnader';
    case '80XX':
    case '81XX':
    case '82XX':
    case '83XX':
    case '84XX':
    case '85XX':
    case '86XX':
    case '87XX':
      return 'Finansiella intäkter och kostnader';
    case '88XX':
      return 'Bokslutsdispositioner';
    case '89XX':
      return 'Årets skatt och resultat';
    case '4XXX':
      return 'Varuinköp';
    case '5XXX':
      return 'Omkostnader';
    case '6XXX':
      return 'Omkostnader';
    case '7XXX':
      return 'Personalkostnader';
    default:
      throw new Error(groupId + ' is invalid');
  }
}

export function accountGroupName(groupId: string): string {
  switch (groupId) {
    case '10XX':
      return 'Immateriella anläggningstillgångar';
    case '11XX':
      return 'Byggnader och mark';
    case '12XX':
      return 'Maskiner och inventarier';
    case '13XX':
      return 'Finansiella anläggningstillgångar';
    case '14XX':
      return 'Lager, produkter i arbete och pågående arbeten';
    case '15XX':
      return 'Kundfordringar';
    case '16XX':
      return 'Övriga kortfristiga fordringar';
    case '17XX':
      return 'Förutbetalda kostnader och upplupna intäkter';
    case '18XX':
      return 'Kortfristiga placeringar';
    case '19XX':
      return 'Kassa och bank';
    case '20XX':
      return 'Eget kapital';
    case '21XX':
      return 'Obeskattade reserver';
    case '22XX':
      return 'Avsättningar';
    case '23XX':
      return 'Långfristiga skulder';
    case '24XX':
      return 'Kortfristiga skulder till kreditinstitut, kunder och leverantörer';
    case '25XX':
      return 'Skatteskulder';
    case '26XX':
      return 'Moms och särskilda punktskatter';
    case '27XX':
      return 'Personalens skatter, avgifter och löneavdrag';
    case '28XX':
      return 'Övriga kortfristiga skulder';
    case '29XX':
      return 'Upplupna kostnader och förutbetalda intäkter';
    case '30XX':
      return 'Försäljning';
    case '31XX':
      return 'Försäljning av varor utanför Sverige';
    case '32XX':
      return 'Försäljning VMB och omvänd moms';
    case '33XX':
      return 'Försäljning av tjänster utanför Sverige';
    case '34XX':
      return 'Försäljning, egna uttag';
    case '35XX':
      return 'Fakturerade kostnader';
    case '36XX':
      return 'Rörelsens sidointäkter';
    case '37XX':
      return 'Intäktskorrigeringar';
    case '38XX':
      return 'Aktiverat arbete för egen räkning';
    case '39XX':
      return 'Övriga rörelseintäkter';
    case '4XXX':
      return 'Varuinköp';
    case '40XX':
      return 'Inköp av varor från Sverige';
    case '41XX':
      return 'Inköp av varor från Sverige';
    case '42XX':
      return 'Sålda varor VMB';
    case '43XX':
      return 'Inköp av varor från Sverige';
    case '44XX':
      return 'Momspliktiga inköp i Sverige';
    case '45XX':
      return 'Övriga momspliktiga inköp';
    case '46XX':
      return 'Legoarbeten och underentreprenader';
    case '47XX':
      return 'Reduktion av inköpspriser';
    case '48XX':
      return '(Fri kontogrupp) 48XX';
    case '49XX':
      return 'Förändring av lager';
    case '5XXX':
      return 'Omkostnader';
    case '50XX':
      return 'Lokalkostnader';
    case '51XX':
      return 'Fastighetskostnader';
    case '52XX':
      return 'Hyra av anläggningstillgångar';
    case '53XX':
      return 'Energikostnader';
    case '54XX':
      return 'Förbrukningsinventarier och förbrukningsmaterial';
    case '55XX':
      return 'Reparation och underhåll';
    case '56XX':
      return 'Kostnader för transportmedel';
    case '57XX':
      return 'Frakter och transporter';
    case '58XX':
      return 'Resekostnader';
    case '59XX':
      return 'Reklam och PR';
    case '6XXX':
      return 'Omkostnader';
    case '60XX':
      return 'Övriga försäljningskostnader';
    case '61XX':
      return 'Kontorsmateriel och trycksaker';
    case '62XX':
      return 'Tele och post';
    case '63XX':
      return 'Företagsförsäkringar och övriga riskkostnader';
    case '64XX':
      return 'Förvaltningskostnader';
    case '65XX':
      return 'Övriga externa tjänster';
    case '66XX':
      return '(Fri kontogrupp) 66XX';
    case '67XX':
      return '(Fri kontogrupp) 67XX';
    case '68XX':
      return 'Inhyrd personal';
    case '69XX':
      return 'Övriga externa kostnader';
    case '7XXX':
      return 'Personalkostnader';
    case '70XX':
      return 'Löner';
    case '71XX':
      return '(Fri kontogrupp) 71XX';
    case '72XX':
      return 'Löner till tjänstemän och företagsledare';
    case '73XX':
      return 'Kostnadsersättningar och förmåner';
    case '74XX':
      return 'Pensionskostnader';
    case '75XX':
      return 'Sociala och andra avgifter enligt lag och avtal';
    case '76XX':
      return 'Övriga personalkostnader';
    case '77XX':
      return 'Nedskrivningar och återföring av nedskrivningar';
    case '78XX':
      return 'Avskrivningar';
    case '79XX':
      return 'Övriga rörelsekostnader';
    case '80XX':
      return 'Finansiella intäkter och kostnader';
    case '81XX':
      return 'Resultat från andelar i intresseföretag';
    case '82XX':
      return 'Ränteintäkter från anläggningstillgångar';
    case '83XX':
      return 'Övriga ränteintäkter';
    case '84XX':
      return 'Räntekostnader';
    case '85XX':
      return '(Fri kontogrupp) 85XX';
    case '86XX':
      return '(Fri kontogrupp) 86XX';
    case '87XX':
      return '(Fri kontogrupp) 87XX';
    case '88XX':
      return 'Bokslutsdispositioner';
    case '89XX':
      return 'Årets skatt och resultat';
    default:
      throw new Error(groupId + ' is invalid');
  }
}

export type AccountGroupCategory =
  'TotalAssets' | 'TotalEquityAndLiabilities' | 'OperatingProfit' | 'AfterFinancialNet' | 'Result';
export function translateAccountGroupCategory(category: AccountGroupCategory): string {
  switch (category) {
    case 'TotalAssets':
      return 'Summa tillgångar';
    case 'TotalEquityAndLiabilities':
      return 'Summa eget kapital och skulder';
    case 'OperatingProfit':
      return 'Rörelseresultat';
    case 'AfterFinancialNet':
      return 'Resultat efter finansnetto';
    case 'Result':
      return 'Årets resultat';
  }
}
export const categoryToAccountGroups: Map<AccountGroupCategory, string[]> = new Map([
  [
    'TotalAssets',
    ['_10XX', '_11XX', '_12XX', '_13XX', '_14XX', '_15XX', '_16XX', '_17XX', '_18XX', '_19XX'],
  ],
  [
    'TotalEquityAndLiabilities',
    ['_20XX', '_21XX', '_22XX', '_23XX', '_24XX', '_25XX', '_26XX', '_27XX', '_28XX', '_29XX'],
  ],
  ['OperatingProfit', ['_30XX', '_39XX', '_4XXX', '_5XXX', '_6XXX', '_7XXX', '_78XX']],
  ['AfterFinancialNet', ['_80XX']],
  ['Result', ['_88XX', '_89XX']],
]);
